"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

var _FooterTabbar = _interopRequireDefault(require("components/FooterTabbar"));

var _VanFieldSelectPicker = _interopRequireDefault(require("components/VanFieldSelectPicker"));

var _VanFieldSelectDate = _interopRequireDefault(require("components/VanFieldSelectDate"));

var _validator = _interopRequireDefault(require("@/plugins/validator"));

var _index = require("@/api/goods/index");

var _index2 = require("@/api/user/index");

var _goods = require("@/api/goods");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      goods: {},
      form: {
        policyholder_name: '',
        policyholder_identityno: ''
      },
      dialogVisable: false,
      errorMsg: {},
      rules: {}
    };
  },
  components: {
    FooterTabbar: _FooterTabbar.default,
    VanFieldSelectPicker: _VanFieldSelectPicker.default,
    VanFieldSelectDate: _VanFieldSelectDate.default
  },
  computed: {},
  methods: {
    insureClick: function insureClick() {
      var _this = this;

      this.$toast('系统维护');
      return false;
      this.dialogVisable = true;
      this.$nextTick(function () {
        _this.$refs.policyholder_name.focus();
      });
    },
    confirm: function confirm(action, done) {
      var _this2 = this;

      if (action === 'confirm') {
        done(false);
        (0, _index2.insure)(Object.assign(this.form, {
          goods_id: this.goods.id
        })).then(function (res) {
          if (!res.code) {
            done(true);

            _this2.$toast.success('投保信息填写成功，正在跳转投保页面');

            setTimeout(function () {
              //一秒后跳转登录页面
              console.log(_this2.goods.shop_url);
              location.href = _this2.goods.shop_url;
              /*  // 在dom中添加a标签-注册点击事件打开新窗口-触发点击事件-从dom中移除a标签
                let a = document.createElement('a');
                let url = this.goods.shop_url
                a.id = 'temp';
                document.body.appendChild(a);
                a.addEventListener('click', function(){
                  window.open(url,'_blank');
                });
                a.click();
                document.body.removeChild(a);*/
            }, 2000);
          }
        });
      } else {
        done();
      }
    },
    onSearch: function onSearch() {},
    onCancel: function onCancel() {},
    onClickLeft: function onClickLeft() {
      // this.$toast('onClickLeft');
      this.$router.back(-1);
    },

    /**
       * 验证方法
       * @param callback
       * @param data
       */
    validate: function validate(callback, data) {// console.log(data)
      //  let obj = this

      /*  this.validator.validate((errors, fields) => {
          this.resetField()
          if (errors) {
            let flag = false
            fields.forEach(item => {
              if (!flag) {
                flag = item.message
              }
            })
            if (flag) {
              this.$toast(flag)
            }
          } else {
            let res = []
            let tips = ''
            Object.keys(this.data).forEach((key) => {
              let index = key.substr(6)
              res.push({
                id: this.goods.fieldmatch[index].field.id,
                name: this.goods.fieldmatch[index].field.name,
                value: this.data[key]
              })
              tips += this.goods.fieldmatch[index].field.name + ':' + this.data[key] + '\n'
            })
            obj.$dialog.confirm({
              title: '确认信息',
              message: tips
            }).then(() => {
              AddProfile(obj.goods.id, { 'data': res }).then((res) => {
                // 跳转到商品详情页面并且传值
                obj.$router.push({
                  name: 'Prodetail',
                  query: {
                    id: obj.goods.id,
                    profile_id: res.data.id
                  }
                })
              })
            }).catch(() => {
            })
          }
          callback && callback(errors, fields)
        }, data)*/
    },
    submit: function submit() {
      this.validate(function (errors, fields) {// this.$dialog.alert(this.data);
      });
    },

    /**
       * 清除验证提示
       * @param attrs
       */
    resetField: function resetField(attrs) {
      var _this3 = this;

      attrs = !attrs ? Object.keys(this.errorMsg) : Array.isArray(attrs) ? attrs : [attrs];
      attrs.forEach(function (attr) {
        _this3.errorMsg[attr] = '';
      });
    },
    reset: function reset() {
      this.data = {
        saleman_name: '',
        saleman_company: ''
      };
      this.validator.setData(this.data);
      this.resetField();
    },
    initData: function () {
      var _initData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$toast.loading({
                  mask: false,
                  message: '加载中...'
                });
                _context.next = 3;
                return (0, _goods.getGoodsProfile)(this.id).then(function (res) {
                  if (res.data) {
                    _this4.profile = res.data.data;
                  }
                });

              case 3:
                _context.next = 5;
                return (0, _index.getGoodsDetail)(this.id).then(function (res) {
                  //    document.title = res.data.name;
                  document.title = res.data.name;
                  /*  res.data.fieldmatch = res.data.fieldmatch.map((d, key) => {
                      if (d.is_must == 1) {
                        console.log(d.field.name + '必填')
                        this.rules['field_' + key] = {
                          required: true,
                          message: '请输入' + d.field.name
                        }
                      }
                      if (d.field.type == 1 || d.field.type == 2) {
                        d.field.options = d.field.options.map((r) => {
                          return r.value
                        })
                      }
                      let profile_value = ''
                      // 投保单号
                      if (this.profile && this.profile[key] && [1, 2, 3].includes(this.profile[key]['id'])) {
                        profile_value = this.profile[key]['value']
                      }
                      this.data['field_' + key] = profile_value
                      return d
                    })*/

                  /*  res.data.fieldmatch = res.data.fieldmatch.map((d, key) => {
                      if (d.is_must == 1) {
                        console.log(d.field.name + '必填')
                        this.rules['field_' + key] = {
                          required: true,
                          message: '请输入' + d.field.name
                        }
                      }
                      if (d.field.type == 1 || d.field.type == 2) {
                        d.field.options = d.field.options.map((r) => {
                          return r.value
                        })
                      }
                      let profile_value = ''
                      // 投保单号
                      if (this.profile && this.profile[key] && [1, 2, 3].includes(this.profile[key]['id'])) {
                        profile_value = this.profile[key]['value']
                      }
                      this.data['field_' + key] = profile_value
                      return d
                    })*/
                  _this4.goods = res.data;

                  _this4.$toast.clear();
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('created');
              this.id = Number(this.$route.params.id);
              _context2.next = 4;
              return this.initData();

            case 4:
              this.validator = (0, _validator.default)(this.rules, this.data);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    console.log('mounted');
  }
};
exports.default = _default;